import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import "./feedback2.css"
import "../Inventory/Inventory.css"
import { isMobile } from "react-device-detect"
import FeedbackGate from "./FeedbackGate"
import useFeedbackGate from "../../helpers/useFeedbackGate"

const questionsData = {
  event: [
    {
      type: "multipleChoice",
      question: "How did you hear about Converge @ walmart",
      options: [
        "Email Campaign",
        "Wallmart Global Tech LinkedIn Page",
        "Word of mouth (Friend/Colleague)",
        "Wallmart Global Tech Website",
        "Other, if so please tell us more",
      ],
    },
    {
      type: "header",
      text: "On a scale of 1 to 5, where 5 means 'Exceeded expectations' and 1 means 'Did not meet expectations' how would you rate the following:",
    },
    { type: "rating", question: "Diversity of speaker", scale: 5 },
    { type: "rating", question: "Session Relevance", scale: 5 },
    { type: "rating", question: "Learning Opportunity", scale: 5 },
    { type: "rating", question: "Experience zone", scale: 5 },
    { type: "rating", question: "Entertainment Quotient", scale: 5 },
    { type: "rating", question: "Networking and Connection", scale: 5 },
    { type: "rating", question: "Overall event experience", scale: 5 },
    {
      type: "rating",
      question:
        "How likely are you to recommend Converge @ Walmart to a colleague or a friend?",
      scale: 10,
    },
    {
      type: "rating",
      question:
        "On a scale of 1 to 10, how likely are you to consider Walmart (or recommend it) as an employer of choice in the retail tech industry?",
      scale: 10,
    },
    {
      type: "multipleChoice&allowed",
      question: "What were the key factors that influenced your rating? (Multiple choice allowed)",
      options: [
        "Best in class technology company",
        "Company culture",
        "Fortune Number One",
        "Making a difference in society",
        "Innovative company",
        "Career growth opportunities",
        "Other, if so please tell us more",
      ],
    },
    {
      type: "yesNo",
      question: "Would you consider working at Walmart Global Tech?",
    },
  ],

  network: [
    {
      type: "multipleChoice",
      question:
        "How valuable was the networking session in helping you connect with peers or Walmart leaders? (1= Not Valuable 5=Most Valuable)",
      options: ["1", "2", "3", "4", "5"],
    },
    {
      type: "multipleChoice&allowed",
      question:
        "What could improve the networking experience at future Converge events? (Multiple choice allowed)",
      options: [
        "Better matching with relevant attendees",
        "More time for networking",
        "Smaller, topic-based groups",
        "Easier access to Walmart leaders",
        "It worked well for me",
      ],
    },
    {
      type: "multipleChoice",
      question:
        "Which of the following areas best represents your expertise?",
      options: [
        "Software Engineering (Individual Contributor)",
        "Software Engineering (People Leader)",
        "Data Analytics",
        "Data Engineering and Architecture",
        "Product Management",
        "Technical Product Management",
        "Other, if so please tell us more",
      ],
    },
  ],
}

const OTHER_LABEL = "Other, if so please tell us more"

const Feedback = () => {
  const location = useLocation()

  // ── Core page state ────────────────────────────────────────────────────
  const [feedType, setFeedType]           = useState(null)
  const [checkingAccess, setCheckingAccess] = useState(true)
  const [answers, setAnswers]             = useState([])
  const [questions, setQuestions]         = useState([])
  const [submitted, setSubmitted]         = useState(false)

  // ── Gate: "accepted" means the user clicked Accept on the rules card ──
  // Once accepted, the gate is dismissed and the form shows.
  const [gateAccepted, setGateAccepted]   = useState(false)

  // ── Leaderboard gate hook ──────────────────────────────────────────────
  // Checks if the user already has an "eventFeedback" / "networkFeedback"
  // entry in the leaderboard. feedType is null until the URL param is read.
  const { gateStatus, quizScore, dismiss } = useFeedbackGate(feedType)

  const fetchAndStoreData = async () => {
    const adminPanel = isMobile
      ? `${process.env.REACT_APP_ADMIN}`
      : `${process.env.REACT_APP_ADMIN_LAPTOP}`

    try {
      const authUser = JSON.parse(localStorage.getItem("authUser"))
      const userResponse = await fetch(`${adminPanel}/getUser/${authUser._id}`)
      const userData = await userResponse.json()
      localStorage.setItem("authUser", JSON.stringify(userData))
    } catch (error) {
      console.error("Failed to fetch data:", error)
    }
  }

  useEffect(() => {
    const init = async () => {
      await fetchAndStoreData()

      const params = new URLSearchParams(location.search)
      const type = params.get("feed") === "network" ? "network" : "event"
      setFeedType(type)

      const data = JSON.parse(localStorage.getItem("authUser"))
      const ticketVariant = data?.Ticket_Variant?.toLowerCase() || ""

      if (!ticketVariant.includes("network") && type === "network") {
        alert("User not allowed")
        window.location.href = "/page/Lobby"
        return
      }

      // NOTE: We intentionally do NOT check data?.eventFeedback here anymore.
      // The leaderboard check via useFeedbackGate handles duplicate detection,
      // which is more reliable since it reads from the same DB the score is
      // written to. The original check below is kept as a comment for reference:
      //
      // const alreadySubmitted =
      //   (type === "event" && data?.eventFeedback?.Data?.length > 0) ||
      //   (type === "network" && data?.networkFeedback?.Data?.length > 0)
      // if (alreadySubmitted) {
      //   alert("You have already submitted the feedback.")
      //   window.location.href = "/page/Lobby"
      //   return
      // }

      setQuestions(questionsData[type])
      setAnswers(new Array(questionsData[type].length).fill(null))
      setCheckingAccess(false)
    }

    init()
  }, [location.search])

  // ── Gate handlers ──────────────────────────────────────────────────────
  const handleGateAccept = () => {
    setGateAccepted(true)
    dismiss()
  }

  const handleGateDecline = () => {
    // User declined the rules — send them back to lobby
    window.location.href = "/page/Lobby"
  }

  const handleGateClose = () => {
    // User closed the "already submitted" card — send them back to lobby
    // dismiss()
    window.location.href = "/page/Lobby"
  }

  // ── Answer handlers (unchanged) ────────────────────────────────────────
  const handleOptionChange = (index, option) => {
    const updated = [...answers]
    updated[index] = option
    setAnswers(updated)
  }

  const handleOtherInputChange = (index, value) => {
    const updated = [...answers]
    updated[index] = { type: "other", value }
    setAnswers(updated)
  }

  const toggleMultiOption = (index, option, checked) => {
    const current = Array.isArray(answers[index]) ? [...answers[index]] : []

    if (option === OTHER_LABEL) {
      if (checked) {
        if (!current.some(a => a?.type === "other")) {
          current.push({ type: "other", value: "" })
        }
      } else {
        const filtered = current.filter(a => a?.type !== "other")
        updateAnswerArray(index, filtered)
        return
      }
      updateAnswerArray(index, current)
      return
    }

    if (checked) {
      if (!current.includes(option)) current.push(option)
    } else {
      const filtered = current.filter(a => a !== option)
      updateAnswerArray(index, filtered)
      return
    }

    updateAnswerArray(index, current)
  }

  const updateMultiOtherValue = (index, value) => {
    const current = Array.isArray(answers[index]) ? [...answers[index]] : []
    const updated = current.map(a => (a?.type === "other" ? { ...a, value } : a))
    updateAnswerArray(index, updated)
  }

  const updateAnswerArray = (index, arr) => {
    setAnswers(prev => {
      const next = [...prev]
      next[index] = arr
      return next
    })
  }

  const handleSubmit = async () => {
    const email = JSON.parse(localStorage.getItem("authUser"))?.EmailAddress
    const name  = JSON.parse(localStorage.getItem("authUser"))?.Firstname
    if (!email) return alert("Email not found")

    const score = 100

    const responses = questions.map((q, index) => {
      const ans = answers[index]
      if (Array.isArray(ans)) {
        return {
          question: q.question || q.text,
          answer: ans.map(item => (item?.type === "other" ? item.value : item)),
        }
      }
      return {
        question: q.question || q.text,
        answer: ans?.type === "other" ? ans.value : ans,
      }
    })

    try {
      const res = await fetch(`${process.env.REACT_APP_ADMIN}/feedback`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, name, score, responses, feedType }),
      })

      if (res.status === 200) {
        setSubmitted(true)
      } else {
        const errorData = await res.json()
        console.error("Error response:", errorData)
        alert("Something went wrong. Please try again.")
      }
    } catch (error) {
      console.error("Submission failed", error)
      alert("Submission failed")
    }
  }

  // ── Render guards ──────────────────────────────────────────────────────

  // Still fetching user data
  if (checkingAccess) return null

  // Gate is loading (fetching leaderboard) — show nothing yet
  // The FeedbackGate component handles its own null state for "loading"
  const showGate = (gateStatus === "rules" && !gateAccepted) || gateStatus === "played"

  return (
    <>
      {/* ── Golden RPG Gate Overlay ── */}
      {showGate && (
        <FeedbackGate
          status={gateStatus}
          feedType={feedType}
          score={quizScore}
          onAccept={handleGateAccept}
          onDecline={handleGateDecline}
          onClose={handleGateClose}
        />
      )}

      {/* ── Actual feedback form — rendered but hidden behind gate ── */}
      {/* Only fully interactive once gate is accepted                 */}
      <div
        className="feedback-container"
        style={showGate ? { pointerEvents: "none", userSelect: "none" } : {}}
      >
        <div className="inv-shoot"                aria-hidden="true">
          <span/><span/><span/><span/><span/>
          <span/><span/><span/><span/>
          <i/><b/><em/>
        </div>
        {/* Header */}
        <header className="inv-header">
          <div className="inv-header-line inv-header-line--gold" />
          <h1 className="inv-header-title">
            <span className="inv-header-bracket">[</span>
            FEEDBACK FORM
            <span className="inv-header-bracket">]</span>
          </h1>
          <div className="inv-header-line inv-header-line--gold" />
        </header>

        {submitted ? (
          <div className="thank-you">
            Thanks for your feedback! Want more updates? Follow us{" "}
            <a
              href="https://www.instagram.com/WalmartGlobalTech"
              target="_blank"
              rel="noopener noreferrer"
            >
              @WalmartGlobalTech
            </a>{" "}
            or visit{" "}
            <a
              href="https://tech.walmart.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              tech.walmart.com
            </a>.
          </div>
        ) : (
          <form
            onSubmit={e => {
              e.preventDefault()
              handleSubmit()
            }}
          >
            {questions.map((q, idx) => (
              <div
                key={idx}
                className= {idx == 1 ? "info-block" : "question-block"}
                style={{ "--i": idx }}
              >
                <div className="question-block-inner">
                  {q.type === "header" && <h4 className="question-header">{q.text}</h4>}

                  {/* Single choice */}
                  {q.type === "multipleChoice" && (
                    <>
                      <p className="question">{q.question}</p>
                      <div className="options">
                        {q.options.map((opt, i) => {
                          const isOther = opt === OTHER_LABEL
                          const answer  = answers[idx]
                          return (
                            <div key={i} className="option-item">
                              <label>
                                <input
                                  type="radio"
                                  name={`question-${idx}`}
                                  value={opt}
                                  checked={
                                    (!isOther && answer === opt) ||
                                    (isOther && answer && answer.type === "other")
                                  }
                                  onChange={() =>
                                    isOther
                                      ? handleOtherInputChange(idx, "")
                                      : handleOptionChange(idx, opt)
                                  }
                                  required
                                />
                                {opt}
                              </label>
                              {isOther && answer && answer.type === "other" && (
                                <input
                                  type="text"
                                  className="others-input"
                                  placeholder="Please specify"
                                  value={answer.value}
                                  onChange={e => handleOtherInputChange(idx, e.target.value)}
                                  required
                                />
                              )}
                            </div>
                          )
                        })}
                      </div>
                    </>
                  )}

                  {/* Multi choice (checkboxes) */}
                  {q.type === "multipleChoice&allowed" && (
                    <>
                      <p className="question">{q.question}</p>
                      <div className="options">
                        {q.options.map((opt, i) => {
                          const isOther  = opt === OTHER_LABEL
                          const answer   = answers[idx] || []
                          const isChecked = isOther
                            ? answer.some(a => a?.type === "other")
                            : answer.includes(opt)
                          return (
                            <div key={i} className="option-item">
                              <label>
                                <input
                                  type="checkbox"
                                  name={`question-${idx}`}
                                  value={opt}
                                  checked={isChecked}
                                  onChange={e => toggleMultiOption(idx, opt, e.target.checked)}
                                />
                                {opt}
                              </label>
                              {isOther && answer.some(a => a?.type === "other") && (
                                <input
                                  type="text"
                                  className="others-input"
                                  placeholder="Please specify"
                                  value={answer.find(a => a?.type === "other")?.value || ""}
                                  onChange={e => updateMultiOtherValue(idx, e.target.value)}
                                  required
                                />
                              )}
                            </div>
                          )
                        })}
                      </div>
                    </>
                  )}

                  {/* Ratings */}
                  {q.type === "rating" && (
                    <>
                      <p className="question">{q.question}</p>
                      <div className="options rating">
                        {Array.from({ length: q.scale }, (_, i) => i + 1).map(num => (
                          <label key={num} className="option-item">
                            <input
                              type="radio"
                              name={`question-${idx}`}
                              value={num}
                              checked={answers[idx] === num}
                              onChange={() => handleOptionChange(idx, num)}
                              required
                            />
                            {num}
                          </label>
                        ))}
                      </div>
                    </>
                  )}

                  {/* Yes / No */}
                  {q.type === "yesNo" && (
                    <>
                      <p className="question">{q.question}</p>
                      <div className="options">
                        {["Yes", "No"].map((opt, i) => (
                          <label key={i} className="option-item">
                            <input
                              type="radio"
                              name={`question-${idx}`}
                              value={opt}
                              checked={answers[idx] === opt}
                              onChange={() => handleOptionChange(idx, opt)}
                              required
                            />
                            {opt}
                          </label>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </div>
            ))}

            <button type="submit" className="submit-btn">
              Submit Feedback
            </button>
          </form>
        )}
      </div>
    </>
  )
}

export default Feedback